import { useState } from "react";
import { FiSearch } from "react-icons/fi";
const Search = function ({ searchText, setSearchText }) {


    const [localQuery, setLocalQuery] = useState(searchText || "");

    const handleOnSubmit = (e) => {
        e.preventDefault();

        setSearchText(localQuery);
    };

    return (
        <div className="search-wrapper">
            {/* 🎬 Background Video Layer */}
            <video
                src="https://vcdn.pixabay.com/video/2021/08/09/84375-585695029_tiny.mp4"
                poster="https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1200&auto=format&fit=crop"
                autoPlay
                loop
                muted
                playsInline
                className="bg-video"
            />

            {/* 🌫️ Dark Overlay */}
            <div className="video-overlay"></div>

            {/* 🔍 Search Content */}
            <form onSubmit={handleOnSubmit} className="search-form">
                <h2>What are you craving today?</h2>
                <div className="input-grp">
                    <input
                        type="text"
                        name="food-search"
                        id="food-search"
                        placeholder="Search for biryani, pizza..."
                        value={localQuery}
                        onChange={(e) => setLocalQuery(e.target.value)} // Update locally
                    />
                    <button type="submit">
                        <span className="btn-text">Search</span>
                        <FiSearch className="btn-icon" />
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Search;